import { PaddingInterface } from '../../types';
import { stringOrNumberHelper } from './stringOrNumberHelper';

export const paddingDecorator = ({
	p,
	pt,
	pr,
	pb,
	pl,
	px,
	py,
}: PaddingInterface) => {
	let response = '';
	if (pt) {
		response += `padding-top: ${stringOrNumberHelper(pt)};`;
	}
	if (pr) {
		response += `padding-right: ${stringOrNumberHelper(pr)};`;
	}
	if (pb) {
		response += `padding-bottom: ${stringOrNumberHelper(pb)};`;
	}
	if (pl) {
		response += `padding-left: ${stringOrNumberHelper(pl)};`;
	}
	if (px) {
		response += `
      padding-left: ${stringOrNumberHelper(
				px
			)}; padding-right: ${stringOrNumberHelper(px)};
    `;
	}
	if (py) {
		response += `
      padding-top: ${stringOrNumberHelper(
				py
			)}; padding-bottom: ${stringOrNumberHelper(py)};
    `;
	}
	if (p) {
		response += `padding: ${stringOrNumberHelper(p)};`;
	}
	return response;
};
